import { useState, useEffect } from 'react';
import axios from 'axios';

export const useApiWithAxios = (url, method = 'GET', body = null, options = {},deps=[]) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    const config = {
      method,
      url,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers, // Merge any additional headers passed via options
      },
      data: body, // Axios automatically handles the body for POST requests
      ...options, // Add any additional options (e.g., credentials, etc.)
    };

    try {
      const response = await axios(config);
      setData(response.data);
    } catch (err) {
      // Improved error handling
      if (err.response) {
        setError(err.response.data || err.response.statusText || 'Server Error');
      } else if (err.request) {
        setError('Network Error');
      } else {
        setError(err.message || 'Something went wrong');
      }
    } finally {
      setLoading(false);
    }
  };

  // Execute fetch request on mount or when parameters change
  useEffect(() => {
    fetchData();
  }, [...deps]); // Include dependencies properly

  return { data, error, loading };
};
